export default {
  TITLE: "Special Order Reservations",
  REMAINING_QUANTITY: "Remaining Quantity",
  DELETE_CONFIRMATION: "Delete this special order reservation?",
  DELETED: "Special order reservation deleted",
  NO_RESERVATIONS: "No special order reservations",
};
